"use strict";

///
/// Pour appeler la classe
/// À la soumission d'un formulaire, on appelle :
///	captchaModule.then((module) => {
///	  new module(CALLBACK)
///	});
///
module.exports = class captcha {
	constructor() {
		this.url_post_captcha = '/Captcha/Index';
		this.key_public = '6LfJ3oQqAAAAAF3KNJqUW_O1mUGcOIO2nl0sT73h';
		this.parameters = {};
	}

	initialize(submitMethode, parameters) {
		let self = this;
		if (parameters) {
			this.parameters = parameters;
		}

		// Méthode d'éxecution captcha
		grecaptcha.ready(function () {
			grecaptcha.execute(self.key_public, {
				action: `submit_${self.parameters.id ??= ''}`
			}).then((token) => {
				self.isRobotOrHuman(token, submitMethode)
			}).catch(e => console.error(e))
		});
	}

	// Méthode indiquant si l'utilisateur est un robot ou un humain
	// Elle appelle `submitMethode` si OK
	isRobotOrHuman(token, submitMethode) {
		async function postData(url, donnees) {
			const response = await fetch(url, {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify(donnees)
			});
			return response.json();
		}

		postData(this.url_post_captcha, {
			token: token
		}).then((response) => {
			if (JSON.parse(response).success) {
				submitMethode(this.parameters);
				//console.info('tu es humain')
			} else {
				console.table(this.parameters)
				//console.warn('tu es un robot')
			}
		}).catch(e => {
			console.error(e)
		})
	}
}